import { FC, ReactElement, ReactNode, useMemo } from 'react';
import { Checkbox } from '../../Checkbox/Checkbox';
import { localeStore } from 'src/mobx/localesStore';
import { ICurrencySettings } from 'src/types/branches';
import { IResponseProductModifierOption } from 'src/types/products';
import { formatPriceSettings } from 'src/utils/formatter';
import { getTranslate } from '~/utils/helpers';
import { debounce } from '~/utils/perfomance';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

interface IProps {
  option: IResponseProductModifierOption;
  onPressOption: (option: IResponseProductModifierOption) => void;
  currencySettings?: ICurrencySettings;
  appearance?: 'circle' | 'square';
  children?: ReactNode;
}

const SingleChoiceOption: FC<IProps> = ({ option, ...props }: IProps): ReactElement => {
  const onPressOption = debounce(() => props.onPressOption(option), 100);

  const price = useMemo((): string => {
    return formatPriceSettings(option.selected ? option.price * option.quantity : option.price, props.currencySettings);
  }, [option, props.currencySettings]);
  const units = useMemo((): string[] => productUtils.getResponseProductModifierOptionUnits(option), [option]);

  return (
    <div id={`select_${option.id}`} className="single-choice-option">
      <div onClick={onPressOption} className="single-choice-option__content">
        <Checkbox
          value={Boolean(option.selected)}
          name={option.id}
          label={getTranslate(option.name)}
          onClick={onPressOption}
          appearance={props.appearance || 'circle'}
          className={!option.taxable ? 'w-70' : 'w-78'}
        />
        <div className="single-choice-option__price-block">
          {option.taxable ? null : <p className="single-choice-option__price-block-vat">{localeStore.t('non_taxable')}</p>}
          <p className="single-choice-option__price-block-price text-nowrap">+ {price}</p>
        </div>
      </div>

      {units.length ? (
        <div className="single-choice-option__units pl-8">
          {units.map((unit) => (
            <span key={unit}>{unit}</span>
          ))}
        </div>
      ) : null}

      {props.children}
    </div>
  );
};

export default SingleChoiceOption;
